import {DurationProps} from "../../types-enums/activity-common-properties";

/**
 * Determines whether the `duration` object contains exact dates.
 *
 * @param {DurationProps} duration - An object representing the duration.
 * @returns {boolean} Returns `true` if the `dates` property of the `duration` object is not null,
 * otherwise returns `false`.
 */
export const hasExactDates = (duration: DurationProps) => duration.dates !== null
